import Store from '@/store'

export class MapBackendUtils {

    static fetchMaps() {
        return Store.dispatch("maps-backend/fetchMaps");
    }

    static uploadMap(data) {
        return Store.dispatch("maps-backend/uploadMap", data);
    }

    static removeMap(mapId) {
        return Store.dispatch("maps-backend/removeMap", mapId);
    }

    static setMapAudience(value) {
        return Store.dispatch("maps-backend/setMapAudience", value);
    }

    static setMapCustomName(value) {
        return Store.dispatch("maps-backend/setMapCustomName", value);
    }

    static setMapClientVersion(value) {
        return Store.dispatch("maps-backend/setMapClientVersion", value);
    }

    static duplicateMap(mapName) {
        return Store.dispatch("maps-backend/duplicateMap", mapName);
    }

    static getMap(mapName) {
        return Store.dispatch("maps-backend/getMap", mapName);
    }

    //GETTERS
    static getMaps() {
        return Store.getters["maps-backend/getMaps"];
    }
    //
    // static deployConfig(value, uid) {
    //     return Store.dispatch("backend-store/deployConfig", {value, uid});
    // }
}